/* tslint:disable */
import {
  GameCategory,
  Player,
  Game
} from '../index';

declare var Object: any;
export interface ContentInterface {
  "categoryId"?: any;
  "playerId"?: any;
  "data"?: Array<any>;
  "type"?: string;
  "id"?: any;
  "gameId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  gameCategory?: GameCategory;
  player?: Player;
  game?: Game;
}

export class Content implements ContentInterface {
  "categoryId": any;
  "playerId": any;
  "data": Array<any>;
  "type": string;
  "id": any;
  "gameId": any;
  "createdAt": Date;
  "updatedAt": Date;
  gameCategory: GameCategory;
  player: Player;
  game: Game;
  constructor(data?: ContentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Content`.
   */
  public static getModelName() {
    return "Content";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Content for dynamic purposes.
  **/
  public static factory(data: ContentInterface): Content{
    return new Content(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Content',
      plural: 'content',
      path: 'content',
      idName: 'id',
      properties: {
        "categoryId": {
          name: 'categoryId',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "data": {
          name: 'data',
          type: 'Array&lt;any&gt;'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        gameCategory: {
          name: 'gameCategory',
          type: 'GameCategory',
          model: 'GameCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categoryId',
          keyTo: 'id'
        },
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
      }
    }
  }
}
